export function getSearchParams(): URLSearchParams {
  return new URL(location.href).searchParams;
}
